export default function accessControl(state = {}, { type, payload, id }) {
  switch (type) {
    case 'FETCH_LOG':
      return { log: payload }
    default:
      return state
  }
}
